import {Redirect, Route, Switch} from 'react-router-dom';
import Urls from '../../constants/urls';
import WCScene from './WCScene';
import {
  seat1Hotspots,
  seat2Hotspots,
  bohoHotspots,
  bohemianHotspots,
  sparklingHotspots,
  cutHotspots
} from './data';

const WCRooms = () => {
  return (
    <Switch>
      <Route
        {...Urls.winemakersCut.root}
        render={() => <Redirect to={Urls.winemakersCut.seat1.path} />}
      />
      <Route {...Urls.winemakersCut.seat1}>
        <WCScene
          id="wc-seat1"
          yRotation={360}
          hotspots={seat1Hotspots}
        />
      </Route>
      <Route {...Urls.winemakersCut.seat2}>
        <WCScene
          id="wc-seat2"
          yRotation={360}
          hotspots={seat2Hotspots}
        />
      </Route>
      <Route {...Urls.winemakersCut.bohemianWines}>
        <WCScene
          id="wc-bohemian-wines"
          yRotation={360}
          hotspots={bohemianHotspots}
        />
      </Route>
      <Route {...Urls.winemakersCut.bohoWines}>
        <WCScene
          id="wc-boho-wines"
          yRotation={360}
          hotspots={bohoHotspots}
        />
      </Route>
      <Route {...Urls.winemakersCut.cutWines}>
        <WCScene
          id="wc-cut-wines"
          yRotation={360}
          hotspots={cutHotspots}
        />
      </Route>
      <Route {...Urls.winemakersCut.sparklingWines}>
        <WCScene
          id="wc-sparkling-wines"
          yRotation={360}
          hotspots={sparklingHotspots}
        />
      </Route>
    </Switch>
  );
};

export default WCRooms;
